
export function scrollIntoViewIfNeeded(el: HTMLElement) {
    const scrollParent = el.closest('.overflow-auto, .overflow-x-auto, .overflow-y-auto');
    if(scrollParent) {
        if(scrollParent.scrollWidth > scrollParent.clientWidth || scrollParent.scrollHeight > scrollParent.clientHeight) {
            el.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
    }
}
